module.exports = __webpack_public_path__ + "static/media/HuffingtonPost.3f22a6e4.png";